import type { RouteObject } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import {
  ADMINISTRATOR,
  CUSTOMER_SUCCESS_TEAM,
  IAM_EDITOR,
} from '@/shared/guards/roles';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';

/**
 * Sub-árvore de rotas do módulo de usuários, com gating em dois níveis:
 *
 *  - **Módulo** (lista incluída): `[ADMINISTRATOR, CUSTOMER_SUCCESS_TEAM,
 *    IAM_EDITOR]` — quem tem qualquer um desses entra no módulo e vê a listagem.
 *  - **Detalhe** (`:userId`): `[ADMINISTRATOR, IAM_EDITOR]` — é onde mora o
 *    modal de acessos, que é a razão de o `IAM_EDITOR` existir. Customer success
 *    vê a lista mas é redirecionado ao tentar abrir um usuário.
 *
 * É só UX — a autorização real é do backend, que gateia as duas rotas por
 * `identity.viewer` (o `IAM_EDITOR` a recebe por composição). `CUSTOMER_SUCCESS_TEAM`
 * é papel só-front: não é `perkKey` de nenhuma migration, então quem o tiver e
 * mais nada abre a tela e leva 403 na chamada — dívida anterior a este gating,
 * anotada aqui para não parecer efeito da mudança.
 */
export const usersRoutes: RouteObject[] = [
  {
    element: (
      <RoleGuard roles={[ADMINISTRATOR, CUSTOMER_SUCCESS_TEAM, IAM_EDITOR]} />
    ),
    children: [
      {
        path: 'management/users',
        children: [
          { index: true, element: <UsersPage /> },
          {
            element: <RoleGuard roles={[ADMINISTRATOR, IAM_EDITOR]} />,
            children: [{ path: ':userId', element: <UserDetailPage /> }],
          },
        ],
      },
    ],
  },
];
